import React, { useEffect, useMemo, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Button from "@mui/material/Button"
import Chart from "../../../components/Charts/Chart"
import { Box, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, InputLabel, LinearProgress, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, MenuItem, Select, Switch, TextField, ToggleButton, Typography } from "@mui/material"
import { useSelector } from "react-redux"
import { addChart, editChart } from "../../../store/dashboard/dasboardReducer"
import Filter from "../../../components/Filter/Filter"
import axios from "axios"
import { clearChartFilter } from "../../../store/filter/filterReducer"
import Table from "../../../components/Table/Table"
import { getFilterValues } from "../../../utils/getFilterValues"
import { logOut } from "../../../utils/logOut"
import "./Dasboard.css"
import NoDataOverlay from "../../../utils/NoDataOverlay"
import TranslatedText from "../../../utils/Translate"
import { CallReportFilterData, ContactReportFilterData, ConversationReportFilterData, DashboardFilters } from "../../../components/Filter/FilterData"
import SimplifiedTable from "../../../components/Table/SimpleTable"
import { useSnackbar } from "../../../utils/SnackbarContext"
import { set } from "date-fns"



// Функция для обработки null-значений в массиве объектов
const removeNullKeysFromAllObjects = (arr: any) => {
    if (!Array.isArray(arr) || arr.length === 0) return arr;

    // Собираем все ключи
    const allKeys = new Set<string>();
    arr.forEach(obj => {
        Object.keys(obj).forEach(key => {
            allKeys.add(key);
        });
    });

    // Для каждого ключа определяем, все ли значения null/пустые
    allKeys.forEach(key => {
        const values = arr.map(obj => obj[key]);
        const allNull = values.every(val => val === null || val === '');
        if (allNull) {
            // Если все значения null/пустые — удалить ключ из всех объектов
            arr.forEach(obj => {
                delete obj[key];
            });
        } else {
            // Если есть хотя бы одно не-null — заменить null/пустые на "..."
            arr.forEach(obj => {
                if (obj[key] === null || obj[key] === '') {
                    obj[key] = "...";
                }
            });
        }
    });

    return arr;
};






export default function Dashboard() {
    const fetchParams = useSelector<any>((state: any) => state.filter.filterUserData.chart)
    //chart config to edit
    const [editChartConfig, setEditChartConfig] = useState<any>({
        name: '',
        beforeName: '',
        type: '',
        reportType: '',
        data: '',
        fields: '',
        interval: '',
        params: '',
        realTime: ''
    })
    //Chart config to add new
    const [chartConfig, setChartConfig] = useState<any>(
        {
            name: '',
            type: 'pie',
            reportType: 'contactreport',
            data: '',
            fields: '',
            interval: '300000',
            params: fetchParams,
            realTime: false
        }
    )

    //Get new chart from storage
    const charts = useSelector((state: any) => state.dashboard.charts)

    const { showSnackbar } = useSnackbar();

    const [tableData, setTableData] = useState<any>([])


    console.log(charts);
    //Saved charts to localstorage
    useEffect(() => {
        (accesslevel != '1' || accesslevel != null) && localStorage.setItem(`charts`, JSON.stringify(charts));
    }, [charts])


    function checkName(arr: any, name: string) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].name === name) {
                return false;
            }
        }
        return true;
    }

    const dispatch = useAppDispatch()
    //Set header title to Dashboard
    useEffect(() => {
        dispatch(setCurrentPage('Dashboard'));
    }, [dispatch]);

    const [openDialog, setOpenDialog] = React.useState(false);

    function findIndexByName(name: string, array: any) {
        for (let i = 0; i < array.length; i++) {
            if (array[i].name === name) {
                return i;
            }
        }
        return -1;
    }

    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };


    const handleCloseDialog = () => {
        setOpenDialog(false);
        setTimeout(() => setEditChartConfig({
            name: '',
            beforeName: '',
            type: '',
            reportType: 'contactreport',
            data: '',
            fields: '',
            interval: '300000',
            params: "",
            realTime: false
        }), 100)
        dispatch(clearChartFilter())
        setChecked([])
        setCheckedList([])
        setTableData([])
    };

    const HandleAddChart = () => {
        setOpenDialog(false);
        console.log(chartConfig);

        dispatch(addChart({ ...chartConfig, params: fetchParams }))
        setChartConfig({
            name: '',
            type: '',
            reportType: 'contactreport',
            data: '',
            fields: '',
            interval: '300000',
            params: '',
            realTime: false,
            dateInterval: ''
        })
        dispatch(clearChartFilter())
        setChecked([])
        setCheckedList([])
        setTableData([])
    };
    const handleEditChart = () => {
        dispatch(editChart(charts.map((el: any, i: any) => {
            if (findIndexByName(editChartConfig.beforeName, charts) === i) {
                return { name: editChartConfig.name, type: editChartConfig.type, reportType: editChartConfig.reportType, data: checkedList, fields: checked, interval: editChartConfig.interval, params: fetchParams, realTime: editChartConfig.realTime, dateInterval: editChartConfig.dateInterval }
            }
            return el
        })))

        setChartConfig({
            name: '',
            type: '',
            reportType: 'contactreport',
            data: '',
            fields: '',
            interval: '300000',
            realTime: false,
            dateInterval: ''
        })
        handleCloseDialog()
        dispatch(clearChartFilter())
        setChecked([])
        setCheckedList([])
        setTableData([])
    };

    const [loading, setLoading] = useState(false)

    //Get report data to create Chart
    async function fetchData(params: any = {}) {
        setLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/${editChartConfig.beforeName !== '' ? editChartConfig.reportType : chartConfig.reportType}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
                params: params
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setTableData(removeNullKeysFromAllObjects(response.data))

                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }
            setLoading(false)
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }


    //On open edit modal get Chart filter config
    useEffect(() => {
        editChartConfig.beforeName !== '' && fetchData(getFilterValues(editChartConfig.params))
        // console.log(editChartConfig.name === '' || editChartConfig.type === '' || editChartConfig.data.length === 0 || editChartConfig.fields.length !== 2 || editChartConfig.interval === '' || !checkName(charts, editChartConfig.name) && editChartConfig.name !== editChartConfig.beforeName)


    }, [editChartConfig.beforeName])

    const memoizedTable = useMemo(() => <SimplifiedTable rows={typeof (tableData) === 'object' ? tableData : []} page={'report'} />, [tableData]);

    console.log(tableData);



    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    const [checked, setChecked] = React.useState<any>(editChartConfig.fields !== "" ? editChartConfig.fields : []);
    const [checkedList, setCheckedList] = React.useState<any>(editChartConfig.data !== "" ? editChartConfig.data : []);

    //On open edit chart modal, set chart checkedList values
    useEffect(() => {
        console.log(editChartConfig);
        editChartConfig.beforeName !== '' ? setChecked(editChartConfig.fields) : setChecked([])
        editChartConfig.beforeName !== '' ? setCheckedList(editChartConfig.data) : setCheckedList([])


    }, [openDialog])


    console.log(checked);
    console.log(checkedList);

    console.log(editChartConfig);

    //On toggle fields of report
    const handleToggle = (value: any) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
        setChartConfig({ ...chartConfig, fields: newChecked })
    };
    //On toggle values list to display at chart
    const handleToggleList = (value: unknown) => () => {
        if (checkedList === 'all') return
        const currentIndex = checkedList.indexOf(value);
        const newChecked = [...checkedList];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }


        setCheckedList(newChecked);
        setChartConfig({ ...chartConfig, data: newChecked })
        console.log(checkedList);
        console.log(checked);
    };

    const handleToggleAll = () => {
        if (checkedList === 'all') {
            setCheckedList([])
            setChartConfig({ ...chartConfig, data: [] })
        }
        else {
            setCheckedList('all')
            setChartConfig({ ...chartConfig, data: 'all' })
        }
    }



    return (
        <>
            <Button onClick={handleClickOpenDialog} size="small" sx={{ mr: 1, mb: 2 }} variant="outlined"><TranslatedText text="Add chart" /></Button>
            <Box
                className="chart-container"
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 3,
                    justifyContent: 'center',
                }}
            >

                {charts.length === 0 ?
                    <Box sx={{ mt: '19vh' }}>
                        <NoDataOverlay />
                    </Box>

                    :
                    charts.map((el: any) => {
                        return (
                            <Chart handleClickOpenDialog={handleClickOpenDialog} setEditChartConfig={setEditChartConfig} dateInterval={el.dateInterval} realTime={el.realTime} type={el.type} name={el.name} data={el.data} fields={el.fields} interval={el.interval} params={el.params} reportType={el.reportType} key={el.name} />
                        )
                    })
                }
            </Box>
            {editChartConfig.beforeName === '' ?
                <Dialog fullWidth={true} maxWidth={false} open={openDialog} onClose={handleCloseDialog}>
                    <DialogTitle><TranslatedText text="Add chart" /></DialogTitle>
                    <DialogContent sx={{ minHeight: '70vh' }}>
                        <Box sx={{ width: '100%', display: "flex", justifyContent: "space-between", flexDirection: 'column', mt: 2, mb: 2 }}>
                            <FormControl>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={"From report*"} /></InputLabel>
                                <Select key={chartConfig.reportType} sx={{ width: "100%" }} labelId="simple-select-label" value={chartConfig.reportType} onChange={(e) => setChartConfig({ ...chartConfig, reportType: e.target.value })} variant="outlined" size="small" label={<TranslatedText text="From report*" />} >
                                    <MenuItem value={"contactreport"}><TranslatedText text="Contact Report" /></MenuItem>
                                    <MenuItem value={"callreport"}><TranslatedText text="Call Report" /></MenuItem>
                                    <MenuItem value={"conversationreport"}><TranslatedText text="Conversation report" /></MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <Filter exclude={accesslevel !== "5" ? ['partnerbank'] : []} filtersList={chartConfig.reportType == "conversationreport" ? ConversationReportFilterData : chartConfig.reportType == "callreport" ? CallReportFilterData : ContactReportFilterData} fetchData={(params: object) => fetchData(params)} page="chart" />
                        {loading ? <LinearProgress sx={{ width: "50%", margin: "40vh auto" }} /> : <Box sx={{ maxHeight: 450, overflow: 'auto' }}>{memoizedTable}</Box>}
                        <Box sx={{ width: '100%', display: "flex", justifyContent: "space-between", flexDirection: 'column', height: 100, mt: 2 }}>
                            {tableData.length !== 0 &&
                                <Typography color={"GrayText"}><TranslatedText text='Select in order: 1 - the name of the data group / 2 - value
                            (if you use "Chart with timestamp", then the name can be any, only the value is used):' /></Typography>
                            }
                            <List dense sx={{ width: '100%', display: 'flex', bgcolor: 'background.paper', gap: 1, flexWrap: 'wrap', mb: 2 }}>

                                {tableData.length !== 0 && Object.keys(tableData[0]).map((value: any, i) => {

                                    console.log(Object.keys(tableData[0]));

                                    const labelId = `checkbox-list-secondary-label-${value}`;

                                    return (
                                        // <ToggleButton
                                        //     key={i}
                                        //     value="check"
                                        //     selected={checked.indexOf(value) !== -1}
                                        //     onChange={handleToggle(value)}
                                        // >
                                        //     <Typography fontSize={12}>
                                        //         {value}
                                        //     </Typography>
                                        // </ToggleButton>

                                        <ListItem
                                            sx={{ border: '1px solid #e0e0e0', borderRadius: 4, maxWidth: 240 }}
                                            key={value}
                                            secondaryAction={
                                                <Checkbox
                                                    disabled={!tableData[0][value] || (checked.length === 2 && !checked.includes(value))}
                                                    edge="end"
                                                    onChange={handleToggle(value)}
                                                    checked={checked.indexOf(value) !== -1}
                                                    inputProps={{ 'aria-labelledby': labelId }}
                                                />
                                            }
                                            disablePadding
                                        >
                                            <ListItemButton disabled={!tableData[0][value] || (checked.length === 2 && !checked.includes(value))} onClick={handleToggle(value)}>
                                                <ListItemText id={labelId} primary={value} />
                                            </ListItemButton>
                                        </ListItem>
                                    );
                                })}
                            </List>
                            {tableData.length !== 0 &&
                                // <Typography color={"GrayText"}><TranslatedText text="Select which pairs the chart will contain (name - value):" /></Typography>
                                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography color={"GrayText"}><TranslatedText text="Select which pairs the chart will contain (name - value):" /></Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Typography color={"GrayText"}><TranslatedText text="Select all" /></Typography>
                                        <Checkbox
                                            // disabled={!value[checked[0]] || !value[checked[1]]}
                                            edge="end"
                                            onChange={() => handleToggleAll()}
                                            checked={checkedList === 'all'}
                                        // inputProps={{ 'aria-labelledby': labelId }}
                                        />
                                    </Box>
                                </Box>
                            }
                            <List dense sx={{ width: '100%', display: 'flex', bgcolor: 'background.paper', gap: 1, flexWrap: 'wrap', mb: 2 }}>
                                {tableData.length !== 0 && tableData.map((value: any, i: any) => {
                                    const labelId = `checkbox-list-secondary-label-${value}`;
                                    return (
                                        <ListItem
                                            sx={{ border: '1px solid #e0e0e0', borderRadius: 1, width: '100%' }}
                                            key={i}
                                            secondaryAction={
                                                <Checkbox
                                                    onChange={handleToggleList(i)}
                                                    disabled={!value[checked[0]] || !value[checked[1]]}
                                                    edge="end"
                                                    checked={checkedList.indexOf(i) !== -1 || checkedList === 'all'}
                                                    inputProps={{ 'aria-labelledby': labelId }}
                                                />
                                            }
                                            disablePadding
                                        >
                                            <ListItemButton disabled={!value[checked[0]] || !value[checked[1]]} onClick={handleToggleList(i)}>
                                                <ListItemText id={labelId} primary={(value[checked[0]] || 'Not selected') + " - " + (value[checked[1]] || 'Not selected')} />
                                            </ListItemButton>
                                        </ListItem>
                                    );
                                })}
                            </List>
                            <TextField sx={{ mb: 2 }} error={!checkName(charts, chartConfig.name)} value={chartConfig.name} onChange={(e) => setChartConfig({ ...chartConfig, name: e.target.value })} size="small" label={<TranslatedText text="Unique chart name*" />} variant="outlined" />
                            {/* <TextField value={chartConfig.type} onChange={(e) => setChartConfig({ ...chartConfig, type: e.target.value })} size="small" label="Chart type*" variant="outlined" /> */}
                            <FormControl sx={{ mb: 2 }}>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text='Chart type' /></InputLabel>
                                <Select key={chartConfig.type} sx={{ width: "100%" }} labelId="simple-select-label" value={chartConfig.type} onChange={(e) => setChartConfig({ ...chartConfig, type: e.target.value, realTime: (e.target.value != 'line' && e.target.value != 'area') ? false : chartConfig.realTime })} variant="outlined" size="small" label={<TranslatedText text='Chart type' />} >
                                    <MenuItem value={"pie"}><TranslatedText text='Pie' /></MenuItem>
                                    <MenuItem value={"donut"}><TranslatedText text='Donut' /></MenuItem>
                                    <MenuItem value={"polarArea"}><TranslatedText text='Polar area' /></MenuItem>
                                    <MenuItem value={"bar"}><TranslatedText text='Bar' /></MenuItem>
                                    <MenuItem value={"line"}><TranslatedText text='Line' /></MenuItem>
                                    <MenuItem value={"area"}><TranslatedText text='Area' /></MenuItem>
                                </Select>
                            </FormControl>
                            {(chartConfig.type === 'line' || chartConfig.type === 'area') && <FormControlLabel sx={{ mb: 2 }} control={<Switch checked={Boolean(chartConfig.realTime)} onClick={() => setChartConfig({ ...chartConfig, realTime: !chartConfig.realTime })} />} label={<TranslatedText text="Line chart with timestamp" />} />}
                            <FormControl sx={{ mb: 2 }}>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text='Update interval' /></InputLabel>
                                <Select sx={{ width: "100%" }} labelId="simple-select-label" value={chartConfig.interval} onChange={(e) => setChartConfig({ ...chartConfig, interval: e.target.value })} variant="outlined" size="small" label={<TranslatedText text='Update interval' />} >
                                    <MenuItem value={"60000"}>1m</MenuItem>
                                    <MenuItem value={"180000"}>3m</MenuItem>
                                    <MenuItem value={"300000"}>5m</MenuItem>
                                    <MenuItem value={"600000"}>10m</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text='Time frame' /></InputLabel>
                                <Select sx={{ width: "100%" }} labelId="simple-select-label" value={chartConfig.dateInterval} onChange={(e) => setChartConfig({ ...chartConfig, dateInterval: e.target.value })} variant="outlined" size="small" label={<TranslatedText text='Time frame' />} >
                                    <MenuItem value={""}><TranslatedText text='Selected date/time in filter' /></MenuItem>
                                    <MenuItem value={"5m"}>5m</MenuItem>
                                    <MenuItem value={"10m"}>10m</MenuItem>
                                    <MenuItem value={"30m"}>30m</MenuItem>
                                    <MenuItem value={"1h"}>1h</MenuItem>
                                    <MenuItem value={"12h"}>12h</MenuItem>
                                    <MenuItem value={"24h"}>24h</MenuItem>
                                    <MenuItem value={"1w"}>1 week</MenuItem>
                                    <MenuItem value={"1mon"}>1 month</MenuItem>
                                </Select>
                            </FormControl>
                            <br />
                        </Box>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog}><TranslatedText text='Cancel' /></Button>
                        <Button disabled={chartConfig.name === '' || chartConfig.type === '' || chartConfig.data.length === 0 || chartConfig.fields.length !== 2 || chartConfig.interval === '' || !checkName(charts, chartConfig.name)} onClick={HandleAddChart}><TranslatedText text='Add' /></Button>
                    </DialogActions>
                </Dialog> :

                <Dialog fullWidth={true} maxWidth={false} open={openDialog} onClose={handleCloseDialog}>
                    <DialogTitle><TranslatedText text="Edit Chart" /></DialogTitle>
                    <DialogContent sx={{ minHeight: '70vh' }}>
                        <Box sx={{ width: '100%', display: "flex", justifyContent: "space-between", flexDirection: 'column', mt: 2, mb: 2 }}>
                            <FormControl>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text="From report*" /></InputLabel>
                                <Select key={editChartConfig.reportType} sx={{ width: "100%" }} labelId="simple-select-label" value={editChartConfig.reportType} onChange={(e) => setEditChartConfig({ ...editChartConfig, reportType: e.target.value })} variant="outlined" size="small" label={<TranslatedText text="From report*" />} >
                                    <MenuItem value={"contactreport"}><TranslatedText text="Contact Report" /></MenuItem>
                                    <MenuItem value={"callreport"}><TranslatedText text="Call Report" /></MenuItem>
                                    <MenuItem value={"conversationreport"}><TranslatedText text="Conversation report" /></MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <Filter filter={editChartConfig.params} filtersList={editChartConfig.reportType == "conversationreport" ? ConversationReportFilterData : editChartConfig.reportType == "callreport" ? CallReportFilterData : ContactReportFilterData} exclude={accesslevel !== "5" ? ['partnerbank'] : []} fetchData={(params: object) => { setChecked([]); setCheckedList([]); return fetchData(params) }} page="chart" />
                        {loading ? <LinearProgress sx={{ width: "50%", margin: "40vh auto" }} /> : <Box sx={{ maxHeight: 450, overflow: 'auto' }}>{memoizedTable}</Box>}
                        <Box sx={{ width: '100%', display: "flex", justifyContent: "space-between", flexDirection: 'column', height: 100, mt: 2 }}>
                            {tableData.length !== 0 &&
                                <Typography color={"GrayText"}><TranslatedText text='Select in order: 1 - the name of the data group / 2 - value
                            (if you use "Chart with timestamp", then the name can be any, only the value is used):' /></Typography>
                            }
                            <List dense sx={{ width: '100%', display: 'flex', bgcolor: 'background.paper', gap: 1, flexWrap: 'wrap', mb: 2 }}>
                                {tableData.length !== 0 && Object.keys(tableData[0]).map((value: any, i) => {
                                    const labelId = `checkbox-list-secondary-label-${value}`;
                                    return (
                                        // <ToggleButton
                                        //     key={i}
                                        //     value="check"
                                        //     selected={checked.indexOf(value) !== -1}
                                        //     onChange={handleToggle(value)}
                                        // >
                                        //     <Typography fontSize={12}>
                                        //         {value}
                                        //     </Typography>
                                        // </ToggleButton>
                                        <ListItem
                                            sx={{ border: '1px solid #e0e0e0', borderRadius: 4, maxWidth: 240 }}
                                            key={value}
                                            secondaryAction={
                                                <Checkbox
                                                    disabled={!tableData[0][value] || (checked.length === 2 && !checked.includes(value))}
                                                    edge="end"
                                                    onChange={handleToggle(value)}
                                                    checked={checked.indexOf(value) !== -1}
                                                    inputProps={{ 'aria-labelledby': labelId }}
                                                />
                                            }
                                            disablePadding
                                        >
                                            <ListItemButton disabled={!tableData[0][value] || (checked.length === 2 && !checked.includes(value))} onClick={handleToggle(value)}>
                                                <ListItemText id={labelId} primary={value} />
                                            </ListItemButton>
                                        </ListItem>
                                    );
                                })}
                            </List>
                            {tableData.length !== 0 &&
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography color={"GrayText"}><TranslatedText text="Select which pairs the chart will contain (name - value):" /></Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Typography color={"GrayText"}><TranslatedText text="Select all" /></Typography>
                                        <Checkbox
                                            // disabled={!value[checked[0]] || !value[checked[1]]}
                                            edge="end"
                                            onChange={() => handleToggleAll()}
                                            checked={checkedList === 'all'}
                                        // inputProps={{ 'aria-labelledby': labelId }}
                                        />
                                    </Box>
                                </Box>
                            }
                            <List dense sx={{ width: '100%', display: 'flex', bgcolor: 'background.paper', gap: 1, flexWrap: 'wrap', mb: 2 }}>
                                {tableData.length !== 0 && tableData.map((value: any, i: any) => {
                                    console.log(checkedList);

                                    const labelId = `checkbox-list-secondary-label-${value}`;
                                    return (
                                        <ListItem
                                            sx={{ border: '1px solid #e0e0e0', borderRadius: 1, width: '100%' }}
                                            key={i}
                                            secondaryAction={
                                                <Checkbox
                                                    disabled={!value[checked[0]] || !value[checked[1]]}
                                                    edge="end"
                                                    onChange={handleToggleList(i)}
                                                    checked={checkedList.includes(i) || checkedList === 'all'}
                                                    inputProps={{ 'aria-labelledby': labelId }}
                                                />
                                            }
                                            disablePadding
                                        >
                                            <ListItemButton disabled={!value[checked[0]] || !value[checked[1]]} onClick={handleToggleList(i)}>
                                                <ListItemText id={labelId} primary={(value[checked[0]] || 'Not selected') + " - " + (value[checked[1]] || 'Not selected')} />
                                            </ListItemButton>
                                        </ListItem>
                                    );
                                })}
                            </List>
                            <TextField defaultValue={editChartConfig.name} sx={{ mb: 2 }} error={!checkName(charts, editChartConfig.name) && editChartConfig.name !== editChartConfig.beforeName} onBlur={(e) => setEditChartConfig({ ...editChartConfig, name: e.target.value })} size="small" label={<TranslatedText text="Unique chart name*" />} variant="outlined" />
                            {/* <TextField value={chartConfig.type} onChange={(e) => setChartConfig({ ...chartConfig, type: e.target.value })} size="small" label="Chart type*" variant="outlined" /> */}
                            <FormControl sx={{ mb: 2 }}>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text="Chart type" /></InputLabel>
                                <Select key={editChartConfig.type} sx={{ width: "100%" }} labelId="simple-select-label" value={editChartConfig.type} onChange={(e) => setEditChartConfig({ ...editChartConfig, type: e.target.value, realTime: (e.target.value != 'line' && e.target.value != 'area') ? false : editChartConfig.realTime })} variant="outlined" size="small" label={<TranslatedText text="Chart type" />} >
                                    <MenuItem value={"pie"}><TranslatedText text='Pie' /></MenuItem>
                                    <MenuItem value={"donut"}><TranslatedText text='Donut' /></MenuItem>
                                    <MenuItem value={"polarArea"}><TranslatedText text='Polar area' /></MenuItem>
                                    <MenuItem value={"bar"}><TranslatedText text='Bar' /></MenuItem>
                                    <MenuItem value={"line"}><TranslatedText text='Line' /></MenuItem>
                                    <MenuItem value={"area"}><TranslatedText text='Area' /></MenuItem>
                                </Select>
                            </FormControl>
                            {(editChartConfig.type === 'line' || editChartConfig.type === 'area') && <FormControlLabel sx={{ mb: 2 }} control={<Switch checked={Boolean(editChartConfig.realTime)} onClick={() => setEditChartConfig({ ...editChartConfig, realTime: !editChartConfig.realTime })} />} label={<TranslatedText text="Line chart with timestamp" />} />}
                            <FormControl sx={{ mb: 2 }}>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text="Update interval" /></InputLabel>
                                <Select sx={{ width: "100%" }} labelId="simple-select-label" value={editChartConfig.interval} onChange={(e) => setEditChartConfig({ ...editChartConfig, interval: e.target.value })} variant="outlined" size="small" label={<TranslatedText text="Update interval" />} >
                                    <MenuItem value={"60000"}>1m</MenuItem>
                                    <MenuItem value={"180000"}>3m</MenuItem>
                                    <MenuItem value={"300000"}>5m</MenuItem>
                                    <MenuItem value={"600000"}>10m</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text='Time frame' /></InputLabel>
                                <Select sx={{ width: "100%" }} labelId="simple-select-label" value={editChartConfig.dateInterval} onChange={(e) => setEditChartConfig({ ...editChartConfig, dateInterval: e.target.value })} variant="outlined" size="small" label={<TranslatedText text='Time frame' />} >
                                    <MenuItem value={""}><TranslatedText text='Selected date/time in filter' /></MenuItem>
                                    <MenuItem value={"5m"}>5m</MenuItem>
                                    <MenuItem value={"10m"}>10m</MenuItem>
                                    <MenuItem value={"30m"}>30m</MenuItem>
                                    <MenuItem value={"1h"}>1h</MenuItem>
                                    <MenuItem value={"12h"}>12h</MenuItem>
                                    <MenuItem value={"24h"}>24h</MenuItem>
                                    <MenuItem value={"1w"}>1 week</MenuItem>
                                    <MenuItem value={"1mon"}>1 month</MenuItem>
                                </Select>
                            </FormControl>
                            <br />
                        </Box>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog}><TranslatedText text="Cancel" /></Button>
                        <Button disabled={checked.length < 2 || checkedList.length === 0 || (!checkName(charts, editChartConfig.name) && editChartConfig.name != editChartConfig.beforeName)} onClick={handleEditChart}><TranslatedText text="Save" /></Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    )
}